module.exports = __webpack_public_path__ + "assets/img/5.54f0edf9.png";